import * as React from 'react';
import '../../Css/Global/Global.css';
import InfoCard from '../Dashboard/InfoCard';
import {Grid, Alert, Snackbar } from "@mui/material";
import CountUp from 'react-countup';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BalanceIcon from '@mui/icons-material/Balance';
import SpedStatusHandler from '../Dashboard/SpedStatusHandler';
import EvolucaoComprasChart from './EvolucaoComprasChart';
import TopChartWithTable from '../../Components/TopChartWithTable';
import TopFornecedoresChart from './TopFornecedoresChart';
import EvolucaoIcmsChart from './EvolucaoIcmsChart';
import { useIcmsCreditosDrillDown } from '../../Hooks/useIcmsCreditosDrillDown';
import IcmsCreditosPeriodoDrillDownModal from '../../Components/IcmsCreditosPeriodoDrillDown/IcmsCreditosPeriodoDrillDownModal';
import { getSafeNumber } from '../../Helpers';
import { getToken as getAuthCookieToken } from '../../Storages/cookies';
import { EstablishmentStorageUtils } from '../../Storages/establishmentStorage';
import CompetenciaStorageUtils from '../../Storages/competenciaStorage';

import { azulMonocromatico20, verdeMonocromatico20, vermelhoMonocromatico20, laranjaMonocromatico20, amareloMonocromatico20 } from '../../Components/collorPallete'
import { FornecedorComprasData } from './types';
import { useSecaoComprasDrillDown } from '../../Hooks/useSecaoComprasDrillDown';
import SecaoComprasDrillDownModal from '../../Components/SecaoComprasDrillDown/SecaoComprasDrillDownModal';
import { SecaoComprasData } from '../../types/secaoComprasDrillDown';
import { useRegiaoComprasDrillDown } from '../../Hooks/useRegiaoComprasDrillDown';
import RegiaoComprasDrillDownModal from '../../Components/RegiaoComprasDrillDown/RegiaoComprasDrillDownModal';
import { RegiaoComprasData } from '../../types/regiaoComprasDrillDown';
import { useProductDrillDown } from '../../Hooks/useProductDrillDown';
import ProductDrillDownModal from '../../Components/ProductDrillDown/ProductDrillDownModal';
import { useFornecedorDrillDown } from '../../Hooks/useFornecedorDrillDown';
import { FornecedorDrillDown } from '../../Components/DrillDown/FornecedorDrillDown';

type ComprasHistoricoData = {
  periodo: string;
  total_compras: number;
};

const AnalisesCompras: React.FC = () => {

    const [loading, setLoading] = React.useState(true);
    const [loadingEvolucaoCompras, setLoadingEvolucaoCompras] = React.useState(true);
    const [loadingTopFornecedoresCompras, setLoadingTopFornecedoresCompras] = React.useState(true);
    
    const [loadingFornecedoresMaioresDescontosCompras, setLoadingFornecedoresMaioresDescontosCompras] = React.useState(true);
    const [loadingFornecedoresMaioresBonificacoesCompras, setLoadingFornecedoresMaioresBonificacoesCompras] = React.useState(true);
    
    const [loadingTopSecoesCompras, setLoadingTopSecoesCompras] = React.useState(true);
    const [loadingTopSecoesCreditos, setLoadingTopSecoesCreditos] = React.useState(true);

    const [loadingFornecedoresMaioresCreditosCompras, setLoadingFornecedoresMaioresCreditosCompras] = React.useState(true);
    const [loadingFornecedoresMenoresCreditosCompras, setLoadingFornecedoresMenoresCreditosCompras] = React.useState(true);
    const [loadingTopProdutosMaioresCreditosCompras, setLoadingTopProdutosMaioresCreditosCompras] = React.useState(true);
    const [loadingTopProdutosCompras, setLoadingTopProdutosCompras] = React.useState(true);

    const [loadingRegioesMaisComprados, setLoadingRegioesMaisComprados] = React.useState(true);

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);
    
    // Estado para armazenar o establishment_id atual
    const [establishmentId, setEstablishmentId] = React.useState<string | number | null>(null);

    const [totalNfesEntrada, setTotalNfesEntrada] = React.useState<number | null>(null);
    const [totalComprado, setTotalComprado] = React.useState<number | null>(null);
    const [ticketMedio, setTicketMedio] = React.useState<number | null>(null);
    const [evolucaoCompras, setEvolucaoCompras] = React.useState<ComprasHistoricoData[]>([]);
    const [topFornecedores, setTopFornecedores] = React.useState<FornecedorComprasData[]>([]);
    const [topFornecedoresDescontos, setTopFornecedoresDescontos] = React.useState<FornecedorComprasData[]>([]);
    const [topFornecedoresBonificacoes, setTopFornecedoresBonificacoes] = React.useState<FornecedorComprasData[]>([]);
    const [topFornecedoresCreditos, setTopFornecedoresCreditos] = React.useState<FornecedorComprasData[]>([]);
    const [topFornecedoresMenoresCreditos, setTopFornecedoresMenoresCreditos] = React.useState<FornecedorComprasData[]>([]);
    const [topProdutosMaioresCreditos, setTopProdutosMaioresCreditos] = React.useState<FornecedorComprasData[]>([]);
    const [topProdutosCompras, setTopProdutosCompras] = React.useState<FornecedorComprasData[]>([]);
    const [topSecoesCompras, setTopSecoesCompras] = React.useState<SecaoComprasData[]>([]);
    const [topSecoesCreditos, setTopSecoesCreditos] = React.useState<SecaoComprasData[]>([]);
    const [topRegioesCompras, setTopRegioesCompras] = React.useState<SecaoComprasData[]>([]);

    // Hook para drill down de seções de compras
    const secaoComprasDrillDown = useSecaoComprasDrillDown();
    const regiaoComprasDrillDown = useRegiaoComprasDrillDown();
    const fornecedorDrillDown = useFornecedorDrillDown({ spedFiscalId: spedFiscalIdSelecionado });

    // Estado para feedback visual
    const [showSpedAlert, setShowSpedAlert] = React.useState(false);

    // Função para lidar com clique em seção
        const ensureSpedSelecionado = React.useCallback((): number | null => {
            if (spedFiscalIdSelecionado && Number(spedFiscalIdSelecionado) > 0) {
                return Number(spedFiscalIdSelecionado);
            }

            const competenciaData = CompetenciaStorageUtils.get();
            if (competenciaData?.sped_fiscal_id) {
                const numericId = Number(competenciaData.sped_fiscal_id);
                if (!Number.isNaN(numericId) && numericId > 0) {
                    setSpedFiscalIdSelecionado(numericId);
                    return numericId;
                }
            }

            return null;
        }, [spedFiscalIdSelecionado]);

        const handleSecaoClick = (secaoData: SecaoComprasData) => {
            const spedId = secaoData.spedFiscalId ?? ensureSpedSelecionado();
          if (spedId) {
              secaoComprasDrillDown.openModal(secaoData, spedId);
          } else {
              setShowSpedAlert(true);
          }
      };

    const handleRegiaoClick = (regiaoData: RegiaoComprasData) => {
        const spedId = regiaoData.spedFiscalId ?? ensureSpedSelecionado();
        if (spedId) {
          regiaoComprasDrillDown.openModal(regiaoData, spedId);
        } else {
          setShowSpedAlert(true);
        }
      }

    const handleFornecedorClick = (fornecedorData: FornecedorComprasData) => {
      const spedId = ensureSpedSelecionado();
      if (!spedId) {
        setShowSpedAlert(true);
        return;
      }
      const nomeFornecedor = fornecedorData?.nome || (fornecedorData as any)?.fornecedor || (fornecedorData as any)?.name;
      const codPart = (fornecedorData as any)?.cod_part;
      console.log('[UI] handleFornecedorClick', { spedId, nomeFornecedor, codPart, fornecedorData });
      if (nomeFornecedor) {
        fornecedorDrillDown.openModal({ nome: nomeFornecedor, cod_part: codPart });
      }
    }

    // Função para fechar o alert
    const handleCloseSpedAlert = () => {
        setShowSpedAlert(false);
    };

    // Helper para headers com auth
    const buildAuthHeaders = () => {
        const token =
            getAuthCookieToken() ||
            localStorage.getItem('token') ||
            sessionStorage.getItem('token') ||
            '';
        const headers: Record<string, string> = { 'Accept': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;
        return headers;
    };



    // ===== FUNÇÕES DE REQUISIÇÃO =====

    // Funções para dados básicos (sem loading)
    const fetchTotalNfesEntrada = async (spedFiscalId: number) => {
        try {
            const totalNfesResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/total-nfes/'+spedFiscalId);
            const totalNfesData = await totalNfesResponse.json();
            setTotalNfesEntrada(getSafeNumber(totalNfesData, 'total_entrada'));
        } catch (e) {
            console.error('Erro ao carregar total de NFEs de entrada', e);
        }
    };

    const fetchTicketMedio = async (spedFiscalId: number) => {
        try {
            const ticketMedioResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/ticket-medio-compras/'+spedFiscalId);
            const ticketMedioData = await ticketMedioResponse.json();
            setTicketMedio(getSafeNumber(ticketMedioData, 'total'));
        } catch (e) {
            console.error('Erro ao carregar ticket médio', e);
        }
    };

    const fetchTotalComprado = async (spedFiscalId: number) => {
        try {
            const totalComprasResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/total-compras/'+spedFiscalId);
            const totalComprasData = await totalComprasResponse.json();
            setTotalComprado(getSafeNumber(totalComprasData, 'total'));
        } catch (e) {
            console.error('Erro ao carregar total comprado', e);
        }
    };

    // Funções para dados com loading
    const fetchEvolucaoCompras = async () => {
        try {
            setLoadingEvolucaoCompras(true);
            
            // Obter establishment_id do localStorage
            const establishmentData = EstablishmentStorageUtils.get();
            const currentEstablishmentId = establishmentData?.establishment_id;
            
            if (!currentEstablishmentId) {
                console.warn('Estabelecimento não selecionado para evolução de compras');
                setEvolucaoCompras([]);
                return;
            }
            
            const EvolucaoComprasResponse = await fetch(
                process.env.REACT_APP_API_URL + 
                `sped-fiscal/evolucao-compras?totalMeses=12&establishment_id=${currentEstablishmentId}`
            );
            const dataEvolucaoCompras: ComprasHistoricoData[] = await EvolucaoComprasResponse.json();
            setEvolucaoCompras(dataEvolucaoCompras);
        } catch (e) {
            console.error('Erro ao carregar evolução das compras', e);
        } finally {
            setLoadingEvolucaoCompras(false);
        }
    };

    const fetchTopFornecedores = async (spedFiscalId: number) => {
        try {
            setLoadingTopFornecedoresCompras(true);
            const TopFornecedoresResponse = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-fornecedores?sped_fiscal_id=${spedFiscalId}`);
            const dataTopFornecedores: FornecedorComprasData[] = await TopFornecedoresResponse.json();
            setTopFornecedores(dataTopFornecedores);
        } catch (e) {
            console.error('Erro ao carregar top fornecedores', e);
        } finally {
            setLoadingTopFornecedoresCompras(false);
        }
    };

    const fetchTopFornecedoresDescontos = async (spedFiscalId: number) => {
        try {
            setLoadingFornecedoresMaioresDescontosCompras(true);
            const responseTopFornecedoresDescontos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-fornecedores-descontos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopFornecedoresDescontos: FornecedorComprasData[] = await responseTopFornecedoresDescontos.json();
            setTopFornecedoresDescontos(dataTopFornecedoresDescontos);
        } catch (e) {
            console.error('Erro ao carregar top fornecedores com descontos', e);
        } finally {
            setLoadingFornecedoresMaioresDescontosCompras(false);
        }
    };

    const fetchTopFornecedoresBonificacoes = async (spedFiscalId: number) => {
        try {
            setLoadingFornecedoresMaioresBonificacoesCompras(true);
            const responseTopFornecedoresBonificacoes = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-fornecedores-bonificacoes?sped_fiscal_id=${spedFiscalId}`);
            const dataTopFornecedoresBonificacoes: FornecedorComprasData[] = await responseTopFornecedoresBonificacoes.json();
            setTopFornecedoresBonificacoes(dataTopFornecedoresBonificacoes);
        } catch (e) {
            console.error('Erro ao carregar top fornecedores com bonificações', e);
        } finally {
            setLoadingFornecedoresMaioresBonificacoesCompras(false);
        }
    };

    const fetchTopSecoesCompras = async (spedFiscalId: number) => {
        try {
            setLoadingTopSecoesCompras(true);
            const responseTopSecoesCompras = await fetch(
                `${process.env.REACT_APP_API_URL}sped-fiscal/top-secoes-compras?sped_fiscal_id=${spedFiscalId}`,
                { headers: buildAuthHeaders(), credentials: 'include' }
            );
            
            if (!responseTopSecoesCompras.ok) {
                throw new Error(`HTTP error! status: ${responseTopSecoesCompras.status}`);
            }
            
            const responseData = await responseTopSecoesCompras.json();
            
            // Verificar se os dados são um array ou têm uma propriedade data
              const dataTopSecoesComprasRaw: SecaoComprasData[] = Array.isArray(responseData) 
                ? responseData 
                : (responseData.data || []);
              const dataTopSecoesCompras = dataTopSecoesComprasRaw.map(item => ({
                ...item,
                spedFiscalId: spedFiscalId
              }));
            
            // Log para debug
            console.log('Top Seções Compras - status', responseTopSecoesCompras.status, 'raw:', responseData, 'processed:', dataTopSecoesCompras);
            
            setTopSecoesCompras(dataTopSecoesCompras);
        } catch (e) {
            console.error('Erro ao carregar top seções de compras', e);
            // Definir como array vazio para evitar erros de renderização
            setTopSecoesCompras([]);
        } finally {
            setLoadingTopSecoesCompras(false);
        }
    };

    const fetchTopSecoesCreditos = async (spedFiscalId: number) => {
        try {
            setLoadingTopSecoesCreditos(true);
            const responseTopSecoesCreditos = await fetch(
                `${process.env.REACT_APP_API_URL}sped-fiscal/top-secoes-maiores-creditos?sped_fiscal_id=${spedFiscalId}`,
                { headers: buildAuthHeaders(), credentials: 'include' }
            );
            
            if (!responseTopSecoesCreditos.ok) {
                throw new Error(`HTTP error! status: ${responseTopSecoesCreditos.status}`);
            }
            
            const responseData = await responseTopSecoesCreditos.json();
            
            // Verificar se os dados são um array ou têm uma propriedade data
              const dataTopSecoesCreditosRaw: SecaoComprasData[] = Array.isArray(responseData) 
                ? responseData 
                : (responseData.data || []);
              const dataTopSecoesCreditos = dataTopSecoesCreditosRaw.map(item => ({
                ...item,
                spedFiscalId: spedFiscalId
              }));
            
            // Log para debug
            console.log('Top Seções Créditos - status', responseTopSecoesCreditos.status, 'raw:', responseData, 'processed:', dataTopSecoesCreditos);
            
            setTopSecoesCreditos(dataTopSecoesCreditos);
        } catch (e) {
            console.error('Erro ao carregar top seções com maiores créditos', e);
            // Definir como array vazio para evitar erros de renderização
            setTopSecoesCreditos([]);
        } finally {
            setLoadingTopSecoesCreditos(false);
        }
    };

    const fetchTopRegioesCompras = async (spedFiscalId: number) => {
        try {
            setLoadingRegioesMaisComprados(true);
            const responseTopRegioesCompras = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-regioes-compras?sped_fiscal_id=${spedFiscalId}`);
              const dataTopRegioesCompras: RegiaoComprasData[] = await responseTopRegioesCompras.json();
              const enriched = dataTopRegioesCompras.map(item => ({
                ...item,
                spedFiscalId: spedFiscalId
              }));
              setTopRegioesCompras(enriched);
        } catch (e) {
            console.error('Erro ao carregar top regiões de compras', e);
        } finally {
            setLoadingRegioesMaisComprados(false);
        }
    };

    const fetchTopFornecedoresCreditos = async (spedFiscalId: number) => {
        try {
            setLoadingFornecedoresMaioresCreditosCompras(true);
            const responseTopFornecedoresCreditos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-fornecedores-creditos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopFornecedoresCreditos: FornecedorComprasData[] = await responseTopFornecedoresCreditos.json();
            setTopFornecedoresCreditos(dataTopFornecedoresCreditos);
        } catch (e) {
            console.error('Erro ao carregar top fornecedores com créditos', e);
        } finally {
            setLoadingFornecedoresMaioresCreditosCompras(false);
        }
    };

    const fetchTopFornecedoresMenoresCreditos = async (spedFiscalId: number) => {
        try {
            setLoadingFornecedoresMenoresCreditosCompras(true);
            const responseTopFornecedoresMenoresCreditos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-fornecedores-menores-creditos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopFornecedoresMenoresCreditos: FornecedorComprasData[] = await responseTopFornecedoresMenoresCreditos.json();
            setTopFornecedoresMenoresCreditos(dataTopFornecedoresMenoresCreditos);
        } catch (e) {
            console.error('Erro ao carregar top fornecedores com menores créditos', e);
        } finally {
            setLoadingFornecedoresMenoresCreditosCompras(false);
        }
    };

    const fetchTopProdutosMaioresCreditos = async (spedFiscalId: number) => {
        try {
            setLoadingTopProdutosMaioresCreditosCompras(true);
            const responseTopProdutosMaioresCreditos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-produtos-maiores-creditos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopProdutosMaioresCreditos: FornecedorComprasData[] = await responseTopProdutosMaioresCreditos.json();
            setTopProdutosMaioresCreditos(dataTopProdutosMaioresCreditos);
        } catch (e) {
            console.error('Erro ao carregar top produtos com maiores créditos', e);
        } finally {
            setLoadingTopProdutosMaioresCreditosCompras(false);
        }
    };

    const fetchTopProdutosCompras = async (spedFiscalId: number) => {
        try {
            setLoadingTopProdutosCompras(true);
            const responseTopProdutosCompras = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-produtos-compras?sped_fiscal_id=${spedFiscalId}`);
            const dataTopProdutosCompras: FornecedorComprasData[] = await responseTopProdutosCompras.json();
            setTopProdutosCompras(dataTopProdutosCompras);
        } catch (e) {
            console.error('Erro ao carregar dados de top produtos compras', e);
        } finally {
            setLoadingTopProdutosCompras(false);
        }
    };

    // Effect para atualizar establishmentId quando página carrega
    React.useEffect(() => {
        const establishmentData = EstablishmentStorageUtils.get();
        if (establishmentData?.establishment_id) {
            setEstablishmentId(establishmentData.establishment_id);
        }
    }, []);

    // Effect para garantir que um SPED previamente selecionado seja reaplicado após reload
    React.useEffect(() => {
        if (spedFiscalIdSelecionado !== null) {
            return;
        }

        const competenciaData = CompetenciaStorageUtils.get();
        if (competenciaData?.sped_fiscal_id) {
            setSpedFiscalIdSelecionado(competenciaData.sped_fiscal_id);
        }
    }, [spedFiscalIdSelecionado]);

    // ===== EFFECT UNIFICADO =====
    
    React.useEffect(() => {
      if (spedFiscalIdSelecionado && Number(spedFiscalIdSelecionado) > 0) {
        // Executa todas as requisições em paralelo
        Promise.all([
          fetchTotalNfesEntrada(spedFiscalIdSelecionado),
          fetchTicketMedio(spedFiscalIdSelecionado),
          fetchTotalComprado(spedFiscalIdSelecionado),
          fetchEvolucaoCompras(), // Agora usa establishment_id internamente
          fetchTopFornecedores(spedFiscalIdSelecionado),
          fetchTopFornecedoresDescontos(spedFiscalIdSelecionado),
          fetchTopFornecedoresBonificacoes(spedFiscalIdSelecionado),
          fetchTopSecoesCompras(spedFiscalIdSelecionado),
          fetchTopSecoesCreditos(spedFiscalIdSelecionado),
          fetchTopRegioesCompras(spedFiscalIdSelecionado),
          fetchTopFornecedoresCreditos(spedFiscalIdSelecionado),
          fetchTopFornecedoresMenoresCreditos(spedFiscalIdSelecionado),
          fetchTopProdutosMaioresCreditos(spedFiscalIdSelecionado),
          fetchTopProdutosCompras(spedFiscalIdSelecionado)
        ]).catch(error => {
          console.error('Erro ao carregar dados das análises de compras:', error);
        });
      }
    }, [spedFiscalIdSelecionado]);

    // Effect adicional para recarregar evolução quando estabelecimento mudar
    React.useEffect(() => {
        if (establishmentId && spedFiscalIdSelecionado) {
            fetchEvolucaoCompras();
        }
    }, [establishmentId]);

    // Novo hook para drill down de créditos ICMS
    const icmsCreditosDrillDown = useIcmsCreditosDrillDown(establishmentId);
    const productDrillDown = useProductDrillDown();

    

    return (
        <>
            <Grid container spacing={0.5}>

            <SpedStatusHandler
                    onSpedFiscalIdChange={(id, dataInicio, dataFim, establishmentId) => {
                        setSpedFiscalIdSelecionado(id);
                        setEstablishmentId(establishmentId ? Number(establishmentId) : null);
                    }}
                />

              <InfoCard title="Análise de Compras" icon={<AddShoppingCartIcon />} iconColor="info" size={12} />

              <InfoCard
                    title="Compras realizadas"
                    value={<CountUp end={totalNfesEntrada || 0} duration={0.5} separator="." preserveValue />}
                    icon={<DocumentScannerIcon />}
                    iconColor="info"
                />

              <InfoCard title="Ticket Médio" value={
                    <CountUp
                        end={ticketMedio || 0}
                        duration={0.5}
                        separator="."
                        decimals={2}
                        decimal=","
                        prefix="R$ "
                        preserveValue
                    />
                }
                    icon={<MonetizationOnIcon />}
                    iconColor="info"
                    
                />
                
                <InfoCard
                  title="Total Comprado"
                  value={
                    <CountUp
                        end={totalComprado || 0}
                        duration={0.5}
                        separator="."
                        decimals={2}
                        decimal=","
                        prefix="R$ "
                        preserveValue
                    />
                  }
                  icon={<MonetizationOnIcon />}
                  iconColor="error"
                  formatAsCurrency={true} size={6}
                  
                />

                <Grid item xs={12}>
                  <EvolucaoComprasChart 
                    data={evolucaoCompras} 
                    loading={loadingEvolucaoCompras}
                    establishmentId={establishmentId}
                    onMissingEstablishment={() => setShowSpedAlert(true)}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable
                    data={topFornecedores}
                    loading={loadingTopFornecedoresCompras}
                    title={'Top 10 Fornecedores por Compras'}
                    color={'orange'}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable
                    data={topFornecedoresDescontos}
                    loading={loadingFornecedoresMaioresDescontosCompras}
                    title={'Top 10 Fornecedores com Maiores Descontos'}
                    color={'#2e7d32'}
                    
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable
                    data={topFornecedoresBonificacoes}
                    loading={loadingFornecedoresMaioresBonificacoesCompras}
                    title={'Top 10 Fornecedores com Maiores Bonificações'}
                    color={'#1976d2'}
                    
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topSecoesCompras} 
                    loading={loadingTopSecoesCompras} 
                    title={'Top 10 Seções por Compras'}
                    color={'green'}
                    tableTitle="Demais Seções"
                    onItemClick={handleSecaoClick}
                  />
                </Grid> 

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable
                    data={topProdutosCompras}
                    loading={loadingTopProdutosCompras}
                    title={'Top 10 Produtos Mais Comprados (Valor)'}
                    color={verdeMonocromatico20}
                    tableTitle="Demais Produtos Comprados"
                    onItemClick={(item) => {
                      if (item.cod_item) {
                        productDrillDown.openModal(item.nome, String(item.cod_item), spedFiscalIdSelecionado || 0);
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topRegioesCompras} 
                    loading={loadingRegioesMaisComprados} 
                    title={'Top 10 Regiões com Maiores Compras (Valor)'}
                    color={verdeMonocromatico20}
                    tableTitle="Demais Regiões"
                    onItemClick={handleRegiaoClick}
                    hasLongLabels={false}
                  />
                </Grid>

                <InfoCard title="Análise de ICMS" icon={<BalanceIcon />} iconColor="info" size={12} loading={loading} />              

                <Grid item xs={12} md={12} lg={12}>
                    {establishmentId != null &&
                        <EvolucaoIcmsChart
                            endpoint={"icms-evolucao-compras/12?establishment_id="+establishmentId}
                            title={"Evolução dos Créditos de ICMS (Últimos 12 meses)"}
                            onBarClick={(params) => {
                              let normalizedSpedId: string | number | undefined = params.sped_fiscal_id;

                              if (Array.isArray(normalizedSpedId)) {
                                normalizedSpedId = normalizedSpedId.join(',');
                              }

                              if (typeof normalizedSpedId === 'string') {
                                const firstId = normalizedSpedId.split(',')
                                  .map((value) => value.trim())
                                  .filter((value) => value.length > 0)[0];
                                if (firstId) {
                                  const parsed = Number(firstId);
                                  if (!Number.isNaN(parsed) && parsed > 0) {
                                    setSpedFiscalIdSelecionado(parsed);
                                  }
                                }
                              } else if (typeof normalizedSpedId === 'number' && normalizedSpedId > 0) {
                                setSpedFiscalIdSelecionado(normalizedSpedId);
                              }

                              icmsCreditosDrillDown.openModal({
                                periodo: params.periodo,
                                sped_fiscal_id: normalizedSpedId
                              });
                            }}
                        />
                    }
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topSecoesCreditos} 
                    loading={loadingTopSecoesCreditos} 
                    title={'Top 10 Seções com Maiores Créditos de ICMS'}
                    color={'blue'}
                    tableTitle="Demais Seções com Créditos ICMS"
                    onItemClick={handleSecaoClick}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                    <TopChartWithTable
                      data={topFornecedoresCreditos}
                      loading={loadingFornecedoresMaioresCreditosCompras}
                      title={'Top 10 Fornecedores com Maiores Créditos de ICMS'}
                      color={'green'}
                      onItemClick={handleFornecedorClick}
                    />
                </Grid> 

                <Grid item xs={12} md={6} lg={6}>
                    <TopChartWithTable
                      data={topFornecedoresMenoresCreditos}
                      loading={loadingFornecedoresMenoresCreditosCompras}
                      title={'Top 10 Fornecedores com Menores Créditos de ICMS'}
                      color={'red'}
                      onItemClick={handleFornecedorClick}
                    />
                </Grid> 

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topProdutosMaioresCreditos} 
                    loading={loadingTopProdutosMaioresCreditosCompras} 
                    title={'Top 10 Produtos com Maiores Créditos de ICMS'}
                    color={'red'}
                    tableTitle="Demais Produtos com Créditos ICMS"
                    onItemClick={(item) => {
                      if (item.cod_item) {
                        productDrillDown.openModal(item.nome, String(item.cod_item), spedFiscalIdSelecionado || 0);
                      }
                    }}
                  />
                </Grid>
              
            </Grid>

            {/* Modal de Drill Down de Seções de Compras */}
            <SecaoComprasDrillDownModal
                isOpen={secaoComprasDrillDown.isModalOpen}
                onClose={secaoComprasDrillDown.closeModal}
                data={secaoComprasDrillDown.drillDownData}
                loading={secaoComprasDrillDown.loading}
                selectedSecao={secaoComprasDrillDown.selectedSecao}
                error={secaoComprasDrillDown.error}
                onRetry={secaoComprasDrillDown.retry}
            />

            <RegiaoComprasDrillDownModal
              isOpen={regiaoComprasDrillDown.isModalOpen}
              onClose={regiaoComprasDrillDown.closeModal}
              data={regiaoComprasDrillDown.drillDownData}
              loading={regiaoComprasDrillDown.loading}
              error={regiaoComprasDrillDown.error}
              selectedRegiao={regiaoComprasDrillDown.selectedRegiao}
              onRetry={regiaoComprasDrillDown.retry}
            />

            <IcmsCreditosPeriodoDrillDownModal
              isOpen={icmsCreditosDrillDown.isModalOpen}
              onClose={icmsCreditosDrillDown.closeModal}
              data={icmsCreditosDrillDown.data}
              loading={icmsCreditosDrillDown.loading}
              error={icmsCreditosDrillDown.error}
              selectedPeriodo={icmsCreditosDrillDown.selectedItem}
              onRetry={icmsCreditosDrillDown.retry}
            />

            <ProductDrillDownModal
              isOpen={productDrillDown.isModalOpen}
              onClose={productDrillDown.closeModal}
              data={productDrillDown.drillDownData}
              loading={productDrillDown.loading}
              error={productDrillDown.error}
              selectedProductName={productDrillDown.selectedProductName}
            />

            {/* Modal de Drill Down de Fornecedores */}
            <FornecedorDrillDown drillDown={fornecedorDrillDown} />

            {/* Feedback Visual para SPED não selecionado */}
            <Snackbar
                open={showSpedAlert}
                autoHideDuration={4000}
                onClose={handleCloseSpedAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleCloseSpedAlert} 
                    severity="warning" 
                    sx={{ width: '100%' }}
                >
                    ⚠️ Selecione primeiro um arquivo SPED fiscal para visualizar os detalhes da seção
                </Alert>
            </Snackbar>             
        </>
      );
      
}


export default AnalisesCompras;

